import axios from '../lib/axios';

const isAuthenticatedApi = () => axios.get('is_authenticated');
const signInApi = (params) => axios.post('auth/sign_in', params);

const updateAccountApi = (params) => axios.put('me', params);
const attachAvatar = (id) => axios.put('me/attach_avatar', { blob: { id } });
const getAvatarDirectUploadUrl = (file, checksum) =>
    axios.post('me/avatar_direct_upload_url', {
        blob: {
            filename: file.name,
            content_type: file.type || 'application/octet-stream',
            byte_size: file.size,
            checksum,
        },
    });

const createAccountApi = (params) => axios.post('auth/sign_up', params);
const resetPasswordRequestApi = (email) => axios.post('auth/reset_password_request', { email });
const resetPasswordApi = (params) => axios.put('auth/reset_password', params);

const getOAuthApi = () => axios.get('auth/oauth');
const linkGoogleUser = (params) => {
    console.log('linkGoogleUser', params);
    const searchParams = new URLSearchParams(params);
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    return axios.post('auth/google_callback', { code, state });
};
const logoutApi = () => axios.post('auth/logout');

export {
    isAuthenticatedApi,
    signInApi,
    updateAccountApi,
    getAvatarDirectUploadUrl,
    attachAvatar,
    createAccountApi,
    resetPasswordRequestApi,
    resetPasswordApi,
    getOAuthApi,
    linkGoogleUser,
    logoutApi,
};
